<template>
  <div
    :class="[
      chosenType != 0 && chosenType != 3
        ? 'app_container back'
        : chosenType == 3
        ? 'app_container back'
        : chosenType == 0
        ? 'app_container'
        : 'app_container back1',
    ]"
  >
    <div class="top_title" v-show="chosenType != 6">
      <img
        src="../../assets/satistics/img-title.png"
        alt=""
        class="top_title_img"
      />
      <img
        src="../../assets/satistics/img-title-effect.png"
        alt=""
        class="top_title_effect"
      />
      <div class="title_text">灵峰村数字乡村大数据平台</div>
      <div class="left_light"></div>
      <div class="right_light"></div>
    </div>

    <div class="content_pad">
      <page-info v-if="chosenType == 0"></page-info>
      <page-monitor v-else-if="chosenType == 2"></page-monitor>
      <page-enviroment
        v-else-if="chosenType == 1"
        @changeBackground="changeBackground"
      ></page-enviroment>
      <page-properties v-else-if="chosenType == 3"></page-properties>
      <page-operation v-else-if="chosenType == 4"></page-operation>
      <!-- <page-map v-else-if="chosenType==6" ></page-map> -->
      <!-- <page-map  ></page-map> -->
    </div>

    <div class="fixed_buttom" v-show="chosenType != 6">
      <div class="relative_content">
        <img
          src="../../assets/satistics/img-bottom1.png"
          alt=""
          class="bottom_img"
        />
        <div class="outer_pad">
          <div
            class="button_item"
            v-for="(item, index) in buttonList"
            :key="index"
            @click="changeType(index)"
          >
            <el-popover
              popper-class="popoverBox"
              v-if="item=='智慧农业'"
              v-model="visible"
              placement="bottom"
              title="请选择跳转地址"
              trigger="manual">
              <div>
                <img src="../../assets/zhny/dh.png" alt="" class="dh">
                <img src="../../assets/zhny/gb.png" alt="" class="gb" @click="close">
                <div class="bodyP">
                  <div @click="skipZhny(1)" class="btn1">智慧农业</div>
                  <!-- <div @click="skipZhny(2)" class="btn2">作物云</div> -->
                </div>
              </div>
              <div slot="reference" @click="visible = true">
                <div class="button_text" :class="{ active: chosenType == index }">
                  {{ item }}
                </div>
                <img
                  :src="[chosenType == index ? selectedButton : unselectedButton]"
                  alt=""
                  class="button_img"
                />
              </div>
            </el-popover>
            <div v-else>
              <div class="button_text" :class="{ active: chosenType == index }">
                {{ item }}
              </div>
              <img
                :src="[chosenType == index ? selectedButton : unselectedButton]"
                alt=""
                class="button_img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="map_button" @click="gomap" v-show="chosenType == 0">
      <img src="../../assets/map4.png" alt="" class="map_icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "statistics",
  data() {
    return {
      bottomVisible: true,
      chosenType: 0,
      isshowtab: true,
      now: new Date(),
      intervalId: null,
      buttonList: [
        "首页",
        "生态人居",
        "环境监测",
        "三资管理",
        "消防安全",
        "智慧农业",
        "智慧水利",
        "后台管理",
      ],
      selectedButton: require("../../assets/satistics/icon-button-selected.png"),
      unselectedButton: require("../../assets/satistics/icon-button-unselected.png"),
      gif1: require("../../assets/satistics/gif-page-back.gif"),
      gif2: require("../../assets/satistics/gif-page-back.gif"),
      visible: false
    };
  },
  components: {
    pageInfo: () => import("./info.vue"),
    pageMonitor: () => import("./monitor.vue"),
    pageEnviroment: () => import("./enviroment.vue"),
    pageProperties: () => import("./properties.vue"),
    pageOperation: () => import("./operation"),
    pageMap: () => import("./map"),
  },
  computed: {
    nowTime: function () {
      let hour =
        this.now.getHours() > 9
          ? this.now.getHours()
          : "0" + this.now.getHours();
      let minute =
        this.now.getMinutes() > 9
          ? this.now.getMinutes()
          : "0" + this.now.getMinutes();
      let second =
        this.now.getSeconds() > 9
          ? this.now.getSeconds()
          : "0" + this.now.getSeconds();

      return hour + ":" + minute + ":" + second;
    },
  },
  created() {
    // this.intervalID = setInterval(() => {
    //   this.now = new Date()
    // }, 1000)
  },
  beforeDestroy() {
    // clearInterval(this.intervalID)
  },
  methods: {
    changeBackground() {
    },
    visibleChange(bool) {
      this.bottomVisible = !bool;
    },

    changeType(index) {
      this.visible = false
      if (index == this.buttonList.length - 1) {
        this.goIndex();
      } else if (index == this.buttonList.length - 3) {
        this.visible = true
      } else if (index == this.buttonList.length - 2) {
        return;
      } else {
        this.chosenType = index;
      }
    },

    goIndex() {
      this.$router.replace("/home");
    },
    gomap() {
      this.$router.replace("/map");
    },
    skipZhny(type) {
      if (type == 1) {
        this.buildDeviceFarmHis();
        // this.$router.replace("/zhny");
        const routeUrl = this.$router.resolve({name: 'zhny'});
        window.open(routeUrl.href, '_blank');
        this.chosenType = 0;
      }
      //  else {
      //   window.open(
      //     "https://www.crop-data.cn/ragis_server_hexinyun/user/singleLogin?userName=相城区农业农村局&password=f6a5295803c62d9f3c803d63768db569"
      //   );
      // }
      this.visible = false
    },
    // 同步智慧农业数据
    buildDeviceFarmHis() {
      this.$http
        .get("api/tDeviceFarmHis/buildDeviceFarmHis")
        .then((res) => {
          if (res.data.code == 200) {

          }
        });
    },
    close(){
      this.visible = false
    },
  },
};
</script>

<style>
.popoverBox {
  border: none;
  background: url("../../assets/zhny/pBg.png") no-repeat;
  background-size: 100%;
  width: 260px;
  height: 120px;
  position: relative;
  cursor: pointer;
}

.popoverBox .el-popover__title {
  color: #fff;
  margin-left: 40px;
}

.popoverBox .dh {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 0;
  left: 0;
}

.popoverBox .gb {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 8px;
  right: 15px;
}

.bodyP {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.bodyP .btn1 {
  width: 108px;
  height: 31px;
  background: url("../../assets/zhny/1.png") no-repeat;
  background-size: 100%;
  font-family: PangMenZhengDao;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 23px;
  letter-spacing: 1px;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.bodyP .btn2 {
  width: 108px;
  height: 31px;
  background: url("../../assets/zhny/2.png") no-repeat;
  background-size: 100%;
  font-family: PangMenZhengDao;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 23px;
  letter-spacing: 1px;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style scoped lang="less">
.map_button {
  position: absolute;
  right: 1rem;
  top: 90%;
  width: 70px;
  z-index: 500;
  /*background: red;*/
  display: flex;
  align-items: center;
  /*border-radius: 4px 4px 15px 15px;*/
  /*background: linear-gradient(to right, rgba(28, 108, 190, 1), rgba(8, 152, 219, 1));*/
  /*padding: 0.2rem 0.6rem;*/
  cursor: pointer;
  user-select: none;

  .map_icon {
    width: 100%;
  }

  .map_text {
    flex: 1;
    font-size: 20px;
    margin: 0 6px;
    color: #fff;
  }

  .map_icon_right {
    width: 15%;
  }
}

@font-face {
  font-family: myTitle;
  src: url("/font/title.ttf");
}

@font-face {
  font-family: myDigib;
  src: url("/font/DS-DIGIB.TTF");
}

@font-face {
  font-family: myNum;
  src: url("/font/number.ttf");
}

@media screen and (max-width: 1699px) {
  .title_text {
    font-size: 42px;
  }
}

@media screen and (min-width: 1700px) {
  .title_text {
    font-size: 46px;
  }
}

@media screen and (min-width: 1800px) {
  .title_text {
    font-size: 50px;
  }
}

@media screen and (min-width: 1920px) {
  .title_text {
    font-size: 54px;
  }
}

.back {
  background-image: url("../../assets/satistics/bg7.gif");
}

.back1 {
  background-image: url("../../assets/satistics/gif-page-back.gif");
}

.back2 {
  background-image: url("../../assets/satistics/page-back2.jpg");
}

.app_container {
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  /*background: rgb(200, 0, 0);*/
  /*background: pink;*/
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 900px;
  min-width: 1600px;

  .top_title {
    position: relative;
    width: 112%;
    left: 50%;
    transform: translate(-50%, -31%);
    z-index: 2;

    .top_title_img {
      width: 100%;
    }

    .top_title_effect {
      position: absolute;
      left: 50%;
      top: 32%;
      transform: translate(-50%, 0);
    }

    .title_text {
      position: absolute;
      font-size: 42px;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 6px;
      text-shadow: 2px 3px 0px #0f298b;
      top: 44%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .left_light {
    position: absolute;
    left: 30%;
    top: 51%;
    width: 45px;
    height: 2px;
    background: linear-gradient(to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 1) 75%,
    rgba(255, 255, 255, 0) 100%);
    animation: leftMove 3s linear 0s infinite;
    z-index: 100;
  }

  .right_light {
    position: absolute;
    right: 30%;
    top: 51%;
    width: 45px;
    height: 2px;
    background: linear-gradient(to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 1) 75%,
    rgba(255, 255, 255, 0) 100%);
    animation: rightMove 3s linear 0s infinite;
    z-index: 100;
  }

  .app_header {
    position: absolute;
    top: 0;
    left: 0;
    height: 9%;
    width: 100%;
    z-index: 100;
    background: linear-gradient(to bottom,
    rgba(22, 48, 106, 0.36) 0%,
    rgba(255, 0, 0, 0) 70%);

    .title_img {
      width: 100%;
      height: 100%;
    }

    .title_text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) skew(-10deg);
      color: #ffffff;
      line-height: 52px;
      font-weight: 600;
      letter-spacing: 2px;
    }

    .time_text {
      position: absolute;
      top: 0.3rem;
      left: 1.2rem;
      font-size: 22px;
      color: #fff;
    }
  }

  .content_pad {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .fixed_buttom {
    position: fixed;
    left: 50%;
    bottom: 0%;
    transform: translate(-50%, 15%);
    width: 95%;
    background: linear-gradient(to top,
    rgba(22, 48, 106, 0.36) 0%,
    rgba(255, 0, 0, 0) 70%);
    z-index: 300;

    .relative_content {
      position: relative;
      width: 100%;

      .bottom_img {
        width: 100%;
      }

      .outer_pad {
        position: absolute;
        bottom: -40%;
        left: 50%;
        transform: translate(-50%, -65%);
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 40%;

        .button_item {
          position: relative;
          width: 50px;
          margin: 0 0.8rem;
          cursor: pointer;
        }

        .button_img {
          width: 100%;
        }

        .button_text {
          position: absolute;
          left: 50%;
          top: 15%;
          transform: translate(-50%, -50%);
          white-space: nowrap;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 28px;
          padding-bottom: 0.5rem;

          &.active {
            color: #00e6ff;
          }
        }
      }
    }
  }
}

@keyframes leftMove {
  0% {
    left: 30%;
  }
  50% {
    left: 16%;
  }
  100% {
    left: 30%;
  }
}

@keyframes rightMove {
  0% {
    right: 30%;
  }
  50% {
    right: 16%;
  }
  100% {
    right: 30%;
  }
}
</style>
